export default {"src":"/_next/static/media/Trash.2692b466.svg","height":16,"width":16};